export const AuthoratorTitle = ({ size = "12rem" }) => {
  return (
    <><span className="authTitle" style={{ fontSize: `${size}` }}>Author</span><span className="authTitle_end" style={{ fontSize: `${size}` }}>ator-ai</span></>
  )
}